import { Box, Card, CardContent, Typography } from '@mui/material'
import { t } from 'i18next'
import { FC } from 'react'
import { themeMeta } from '../../theme/meta'
import { Fa } from '../Fa'
import { SessionSummary } from '../SessionSummary'

const Result: FC<ResultProps> = ({ session }) => {
  return (
    <>
      <Typography variant="h1" mb={3}>
        <Fa name="check-circle" size="2xl" color="success" />
      </Typography>
      <Typography variant="h1" mb={1}>
        {session
          ? t("You're all booked in!")
          : t('You have successfully purchased.')}
      </Typography>
      <Typography>
        {session
          ? t('Open your mobile app to check the details of your class.')
          : t('Open your mobile app to check the details.')}
      </Typography>
      {session && (
        <Box mt={3}>
          <Card sx={{ bgcolor: themeMeta.colors.monochrome.bg }}>
            <CardContent>
              <SessionSummary session={session} />
            </CardContent>
          </Card>
        </Box>
      )}
    </>
  )
}

type ResultProps = {
  session?: Dto.Session
}

export { Result }
export type { ResultProps }
